import { useState } from "react";
import PostDischargeQuickViewPanel from "./PostDischargeQuickViewPanel";
import PostDischargeModal from "../../post-discharge/PostDischargeModal";
import { usePostDischarge } from "./usePostDischarge";
import { usePostDischargeData } from "./uesPostDischargeData";

const PostDischargeQuickView = ({ patientId }: { patientId: number }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	// Same react-query key the modal uses, so the card's event list costs no extra request.
	const postDischarge = usePostDischarge(patientId);

	const postDischargeInfo = usePostDischargeData(patientId);

	const isLoading = postDischargeInfo.isLoading || postDischarge.isLoading;
	const isError = postDischargeInfo.isError || postDischarge.isError;

	return (
		<>
			<PostDischargeQuickViewPanel
				isLoading={isLoading}
				isError={isError}
				postDischargeInfo={postDischargeInfo.data}
				events={postDischarge.data}
				onClickAction={() => setIsModalOpen(true)}
			/>
			{isModalOpen && (
				<PostDischargeModal
					patientId={patientId}
					isVisible={isModalOpen}
					postDischarge={postDischarge.data}
					postDischargeInfo={postDischargeInfo}
					closeModal={() => setIsModalOpen(false)}
				/>
			)}
		</>
	);
};

export default PostDischargeQuickView;
